import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const noticeList = createAsyncThunk('notice/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `notice`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'notice_type': data?.notice_type,
                'start_date': data?.start_date,
                'end_date': data?.end_date,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const noticeDetails = createAsyncThunk('notice/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `notice/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addNotice = createAsyncThunk('notice/add', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append("premise_id", data?.values?.premise_id)
    bodyFormData.append("notice_name", data?.values?.title)
    bodyFormData.append("notice_type_id", data?.values?.notice_type)
    bodyFormData.append("notice_from_date", data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("notice_to_date", data?.values?.end_date && moment(data?.values?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("notice_remark", data?.values?.description)
    bodyFormData.append("zone_id", data?.values?.zone_id ?? '')
    bodyFormData.append("level_id", data?.values?.level_id ?? '')
    bodyFormData.append("unit_id", data?.values?.unit_id ?? '')

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("notice_file", file);
        });
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'notice',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "notice_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateNotice = createAsyncThunk('notice/update', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append("notice_id", data?.values?.id)
    bodyFormData.append("premise_id", data?.values?.premise_id)
    bodyFormData.append("notice_name", data?.values?.title)
    bodyFormData.append("notice_type_id", data?.values?.notice_type)
    bodyFormData.append("notice_from_date", data?.values?.start_date && moment(data?.values?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("notice_to_date", data?.values?.end_date && moment(data?.values?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("notice_remark", data?.values?.description)
    bodyFormData.append("zone_id", data?.values?.zone_id ?? '')
    bodyFormData.append("level_id", data?.values?.level_id ?? '')
    bodyFormData.append("unit_id", data?.values?.unit_id ?? '')

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("notice_file", file);
        });
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_notice',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "notice_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delNotice = createAsyncThunk('notice/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `notice/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delNoticeFile = createAsyncThunk('notice/deleteFile', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `notice_file/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const notice = createSlice({
    name: 'notice',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(noticeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(noticeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default notice.reducer;